import {RentVehicleResponseBody, ReturnVehicleResponseBody} from '@dms/api/rental';

import {Nullish} from 'shared/web';

import {formatFuelTank} from './formatFuelTank';

/** Derived from the API response types, so callers keep passing the whole order. */
export type RentalOrderFuelTankSource = {
  rentVehicle: Pick<RentVehicleResponseBody, 'fuelTank'> | null;
  returnVehicle: Pick<ReturnVehicleResponseBody, 'fuelTank'> | null;
};

/**
 * @about Resolves the fuel tank level shown for a rental order: the level recorded on return,
 * falling back to the level recorded on rent, or null when neither carries a usable level.
 */
export function getRentalOrderFuelTankLevel(
  rentalOrder: RentalOrderFuelTankSource | Nullish
): string | null {
  return formatFuelTank(rentalOrder?.returnVehicle?.fuelTank ?? rentalOrder?.rentVehicle?.fuelTank);
}
